import { Action } from 'redux';
import { DashboardSearch, DashboardState, FDIInvestment } from "../store";

export type Data = FDIInvestment[];

export interface FdiDashboardAction extends Action {
  payload: Data;
  error?: string;
}

export const actionTypes = {
  FDI_DASHBOARD_REQUEST: 'dashboard/FDI_DASHBOARD_REQUEST',
  FDI_DASHBOARD_SUCCESS: 'dashboard/FDI_DASHBOARD_SUCCESS',
  FDI_DASHBOARD_ERROR: 'dashboard/FDI_DASHBOARD_ERROR',
};

export namespace actions {
  export function fetchRequest(search: DashboardSearch) {
    return {
      type: actionTypes.FDI_DASHBOARD_REQUEST,
      payload: search
    };
  }

  export function fetchSuccess(data: Data) {
    return {
      type: actionTypes.FDI_DASHBOARD_SUCCESS,
      payload: data,
    };
  }

  export function fetchFailed(error: string) {
    return {
      type: actionTypes.FDI_DASHBOARD_ERROR,
      payload: { error },
    };
  }
}

export namespace reducers {
  // tslint:disable-next-line:no-any
  export const reducer = (state: DashboardState = { status: 'none' }, action: FdiDashboardAction) => {
    switch (action.type) {
      case actionTypes.FDI_DASHBOARD_REQUEST:
        {
          return {
            status: 'loading',
          };
        }
      case actionTypes.FDI_DASHBOARD_SUCCESS:
        {
          const data: Data = action.payload;
          return {
            status: 'loaded',
            investments: data,
          };
        }
      case actionTypes.FDI_DASHBOARD_ERROR:
        {
          const { error } = action;
          return {
            status: 'error',
            error,
          };
        }
      default:
        return state;
    }
  };
}


// WEBPACK FOOTER //
// ./src/Dashboard/redux.ts